import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import Greeting from "../../../views/popups/mlib/Greeting";
import PopupLoader from "../../../views/popups/PopupLoader";
import AudioPlayer from "../../mediaplayers/AudioPlayer";
import { useFormContext } from "react-hook-form";

const HGVoicemail = ({ incusersup, hgCode, greetingsInfo }) => {
  const { t, i18n } = useTranslation();
  const [enableEmails, setEnableEmails] = useState(true);
  const navigate = useNavigate();
  const [unavailGreeting, setUnavailGreeting] = useState(false);
  const { busy, unavailable } = greetingsInfo ?? {};

  const {
    register,
    formState: { errors },
    setValue,
    getValues,
    watch,
    clearErrors,
    trigger,
  } = useFormContext();

  useEffect(() => {
    if (getValues("voice_mail.email_notify") === true) {
      setEnableEmails(true);
    } else {
      setEnableEmails(false);
    }
  }, [getValues("voice_mail.email_notify")]);

  // function handleToggleFunc() {
  //   const toggleid = document.getElementById("hgemailnotify");
  //   setValue("voice_mail.email_notify", toggleid.checked ? true : false, {
  //     shouldDirty: true,
  //   });
  // }

  function handleCheckBox() {
    const toggcheckboxDiv = document.getElementById("hgemailnotify");
    setValue(
      "voice_mail.inc_user_sup",
      toggcheckboxDiv.checked ? true : false,
      {
        shouldDirty: true,
      }
    );
  }

  const vmGreetingEnable = () => {
    setUnavailGreeting(!unavailGreeting);
  };

  return (
    <>
      <div className="general-settings">{t("Voicemail")}</div>
      <div className="margin-top mb__scroll__voicmain">
        <div className="add-numbermain">
          <div className="tel-numbers">{t("Pin")}</div>
          <div className="d-flex w-30">
            <div className="phoneselect w-100">
              <input
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.stopPropagation();
                    event.preventDefault();
                  }
                }}
                {...register("voice_mail.vm_pin", {
                  setValueAs: (value) => Number(value),
                  pattern: {
                    value: "[0-9]*",
                    message: "Must be numeric",
                  },
                })}
                className="w-100 form-control"
              />
              {errors.voice_mail?.vm_pin && (
                <p className="text-danger">
                  {errors.voice_mail?.vm_pin?.message}
                </p>
              )}
            </div>
          </div>
        </div>

        <div className="add-numbermain add-numbermain-small align-items-start">
          <div>
            <div className="tel-numbers">{t("unavaliableGreeting")}</div>
          </div>

          {/* {hgCode && hgCode !== '' && ( */}
          <AudioPlayer
            uniqueId={hgCode}
            greetingType={unavailable?.greeting_type ?? 1}
            greetingId={unavailable?.greeting_id ?? 0}
            fileName={unavailable?.filename ?? ""}
            title={t("VoicemailUnavailableGreeting")}
            greetingMode={unavailable?.filename ?? "" !== "" ? 1 : 2}
            greetingTitle = {unavailable?.title ?? ""}
            greetingObject = {unavailable ?? null}
          />
          {/* )
          } */}
        </div>

        {/* <div className="add-numbermain add-numbermain-small align-items-start">
          <div>
            <div className="tel-numbers">{t("busyGreeting")}</div>
          </div>
          {hgCode && hgCode !== '' && (<AudioPlayer
            uniqueId={hgCode}
            greetingType={busy?.greeting_type ?? 2}
            greetingId={busy?.greeting_id ?? 0}
            fileName={busy?.filename ?? ''}
            title={t("VoicemailBusyGreeting")}
            greetingMode={busy?.filename ?? '' !== '' ? 1 : 2}
          />)
          }
        </div> */}

        {/* <div className="add-numbermain">
          <div className="tel-numbers">
            {t("play_Mess_timestamp")}
            <br />
          </div>
          <div className="d-flex">
            <div className="phoneselect">
              <div className="phoneselect">
                <label className="switch">
                  <input
                    className="form-control"
                    type="checkbox"
                    {...register("voice_mail.play_msg_time_stmp")}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>
          </div>
        </div> */}
         <div className="add-numbermain">
              <div className="tel-numbers">
                {t("include_Transcript")}
                <br />
                <span className="phrecording text-secondary">
                  {t("vmail_copy_trans_text")}
                </span>
              </div>
              <div className="d-flex">
                <div className="phoneselect">
                  <div className="phoneselect">
                    <label className="switch">
                      <input
                        className="form-control"
                        {...register("voice_mail.email_transcript")}
                        type="checkbox"
                      />
                      <span className="slider round"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
        <div className="add-numbermain">
          <div className="tel-numbers w-35"> 
          <label>  {t("email_notif")} </label>           
          </div>
            <div>
              <div className="phoneselect">
                <label className="switch">
                  <input
                    className="form-control"
                    id="hgemailnotify"
                    checked={watch("voice_mail.email_notify")}
                    type="checkbox"
                    onChange={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      setValue("voice_mail.email_notify", e.target.checked, {
                        shouldDirty: true,
                      });
                       clearErrors("voice_mail.email_notify");

                      // setValue("voice_mail.email_notify", e.target.value === 'on' ? true : false, {shouldDirty: true})
                      // setEnableEmails((obj) => !obj);
                      // handleToggleFunc();
                    }}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
               <div>
               {errors.voice_mail?.email_notify && (
                    <p className="text-danger">
                      {errors.voice_mail?.email_notify?.message}
                    </p>
                  )}
            </div>
          </div>
        </div>
        {watch("voice_mail.email_notify") && (
          <>
            <div className="add-numbermain">
              <div className="tel-numbers">
                {t("email_address")} <br />
                <span className="phrecording text-secondary">
                  {t("vmail_copy_email_text")}
                </span>
              </div>
              <div className="d-flex w-30">
                <div className="phoneselect w-100">
                  <input
                    //    {...register("voice_mail.email_address", {
                    //   required: "Voicemail email is required",
                    // })}
                    {...register("voice_mail.email_address", {
                      onChange: (e) => {
                        // clear error of email_notify
                        clearErrors("voice_mail.email_notify");
                      },
                    })}
                    placeholder="Enter Email Address"
                    className="w-100 form-control"
                  />

                  {/* <p className="mt-2">
                    Include Users and supervisors
                    <input
                      type="checkbox"
                      //checked = {incusersup}
                      //value="Include Users and Supervisors"
                      {...register("voice_mail.inc_user_sup")}
                      //onChange={() => handleCheckBox()}
                      className="ms-2"
                    />
                  </p> */}
                  {errors.voice_mail?.email_address && (
                    <p className="text-danger">
                      {errors.voice_mail?.email_address.message}
                    </p>
                  )}
                </div>
              </div>
            </div>
            <div className="add-numbermain">
              <div className="tel-numbers">
                {t("del_send_message")}
                <br />
              </div>
              <div className="d-flex">
                <div className="phoneselect">
                  <div className="phoneselect">
                    <label className="switch">
                      <input
                        className="form-control"
                        type="checkbox"
                        {...register("voice_mail.vm_delete")}
                      />
                      <span className="slider round"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
           
            <div className="add-numbermain">
              <div className="tel-numbers">
                {t("email_copy_to_all_mem")}
                <br />
              </div>
              <div className="d-flex">
                <div className="phoneselect">
                  <div className="phoneselect">
                    <label className="switch">
                      <input
                        className="form-control"
                        {...register("voice_mail.email_to_members",
                          {onChange: (e) =>  clearErrors("voice_mail.email_notify")}
                        )}
                        type="checkbox"
                      />
                      <span className="slider round"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="add-numbermain">
              <div className="tel-numbers">
                {t("email_copy_to_all_sup")}
                <br />
              </div>
              <div className="d-flex">
                <div className="phoneselect">
                  <div className="phoneselect">
                    <label className="switch">
                      <input
                        className="form-control"
                        {...register("voice_mail.email_to_sup",{onChange: (e) =>  clearErrors("voice_mail.email_notify")})}
                        type="checkbox"
                      />
                      <span className="slider round"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {/* <div className="add-numbermain">
          <div className="tel-numbers">
            {t("boardcast_voicemails")}
            <br />
          </div>
          <div className="d-flex">
            <div className="phoneselect">
              <div className="phoneselect">
                <label className="switch">
                  <input
                    className="form-control"
                    type="checkbox"
                    {...register("voice_mail.broadcast_vm_to_account")}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>
          </div>
        </div> */}
      </div>

      {unavailGreeting && (
        <PopupLoader
          title={t("VoiceMailunavaliableGreeting")}
          content={
            <Greeting
              module="Role"
              greetingType={1}
              uniqueId={hgCode}
              onClose={vmGreetingEnable}
            />
          }
          onShow={setUnavailGreeting}
          onClose={vmGreetingEnable}
        />
      )}
    </>
  );
};

export default HGVoicemail;
